import { useTranslation } from "react-i18next";
import { cn } from "../lib/utils";
import { LANGS } from "../lib/i18n";

export function LanguageToggle() {
  const { i18n, t } = useTranslation("common");
  const current = i18n.resolvedLanguage ?? "uz";

  return (
    <div
      role="group"
      aria-label={t("topbar.language")}
      className="inline-flex items-center rounded-md border border-input bg-background p-0.5 h-9"
    >
      {LANGS.map((lng) => (
        <button
          key={lng}
          type="button"
          onClick={() => i18n.changeLanguage(lng)}
          aria-pressed={current === lng}
          className={cn(
            "px-2 h-8 rounded text-xs font-semibold transition-colors",
            current === lng
              ? "bg-accent text-foreground"
              : "text-muted-foreground hover:text-foreground",
          )}
        >
          {lng.toUpperCase()}
        </button>
      ))}
    </div>
  );
}
